module.exports = __webpack_public_path__ + "images/emoji/8ball.bb16a4f86cf3bb1614ff.png";